import { useTrackWithUser, isAllowedToReadEvents } from '@ion/api';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import { useDrawerContext } from 'app/shared/contexts/drawer';

export default function useRowClickedProps() {
  const [schemaViolationEventsDrawerViewed] = useTrackWithUser('schema_violation_events_drawer_viewed');

  const { schemaViolationEventsMvpEnabled } = useFeatureEnabled(FEATURE_FLAGS.schemaViolationEventsMvp);
  const { launchDrawer } = useDrawerContext();
  const hasPermission = isAllowedToReadEvents();

  const shouldLaunchDrawer = hasPermission && schemaViolationEventsMvpEnabled;

  if (!shouldLaunchDrawer) {
    return {};
  }

  const onRowClicked = row => {
    schemaViolationEventsDrawerViewed();
    launchDrawer({ ...row });
  };

  return {
    onRowClicked,
    highlightOnHover: true,
    pointerOnHover: true,
  };
}
